export const initialValuesIngCollaborator = {
	tags: "",
}
